/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import { BUTTON_COLOR, BUTTON_HEIGHT, BUTTON_WIDTH } from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_900, PHONE_900, URLS } from '../../errorTextsConstants';


export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      OFFER_WITH_SOME_DEPENDENCIES: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Para poder contratar este paquete de TV tienes que hacerlo a través del configurador de miMovistar',
          buttons: [
            {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'oferta con varias dependencias posibles',
        },
      },
      WITHOUT_DEPENDENT_OFFER: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Para poder contratar este paquete de TV tienes que hacerlo a través del configurador de miMovistar',
          buttons: [
            {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'no se tiene oferta dependiente necesaria',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Upss… algo ha ido mal",
          msg: [
            "Se ha producido un error al generar tu pedido.",
            `Por favor, reinténtalo más tarde o llámanos gratis al ${PHONE_900} para que podamos gestionarlo.`,
            "Sentimos las molestias.",
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "error generico",
        },
      },
      BUY_ALREADY_DONE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya has solicitado este cambio en tu pack miMovistar.',
          msg: ['En unas horas lo verás actualizado.', 'Gracias por confiar en Movistar.'],
          buttons: [],
          errorName: 'movimiento seleccionado incorrecto',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
  
    },
  }
};
